import { useState, useCallback, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { routes } from "router/routes"
import { filterSelectedExperiences } from "../utils/resourceHelpers"

/**
 * Hook to manage equipment selection and CRUD operations
 * @param {Array} equipmentData - All available equipment
 * @returns {Object} Equipment state and handlers
 */
export const useEquipmentManagement = (equipmentData) => {
  const navigate = useNavigate()
  const [selectedEquipment, setSelectedEquipment] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])

  // Filter selected equipment data
  const selectedEquipmentData = useMemo(
    () => filterSelectedExperiences(equipmentData, selectedEquipment),
    [equipmentData, selectedEquipment]
  )

  // Handle equipment edit — navigate to the edit route
  const handleEditEquipment = useCallback(
    (record) => {
      navigate(routes.guideEquipmentEditPath({ id: record.id }))
    },
    [navigate]
  )

  // Handle equipment removal
  const handleRemoveEquipment = useCallback((id) => {
    setSelectedEquipment((prev) => prev.filter((expId) => expId !== String(id) && expId !== "all"))
  }, [])

  // Handle add new equipment — navigate to the add route
  const handleOpenModal = useCallback(() => {
    navigate(routes.guideEquipmentAddPath())
  }, [navigate])

  return {
    selectedEquipment,
    setSelectedEquipment,
    selectedCategories,
    setSelectedCategories,
    selectedEquipmentData,
    handleEditEquipment,
    handleRemoveEquipment,
    handleOpenModal
  }
}
